export default __webpack_public_path__ + "static/sol-k12-section-2-img-d1c2db691e5e81d1b3a2b8aaaa6177ad.png";